export const state = () => ({
    hamburger_visible: true,
    logo_visible: true,
    nav_visible: false,
})

export const getters = {
    hamburger_visible: state => state.hamburger_visible,
    logo_visible: state => state.logo_visible,
    nav_visible: state => state.nav_visible,
    nav_visible: state => state.nav_visible
}

export const mutations = {
    /**
     * Set the overall state of the navigation based on the type of state that
     * the application is in.
     * @param {*} state
     * @param {*} cfg
     */
    setNavState(state, cfg) {
        if(cfg === 'intro') {
            state.hamburger_visible = true
            state.logo_visible = true
            state.nav_visible = false
        } else if (cfg === 'activity') {
            state.hamburger_visible = true
            state.logo_visible = false
            state.nav_visible = false
        } else {
            state.hamburger_visible = false
            state.logo_visible = true
            state.nav_visible = true
        }
    },

    /**
     * Set the visibility of the Navigation panel.
     * @param {*} state
     * @param {*} visibility
     */
    setNavVisibility(state, visibility) {
        state.nav_visible = visibility
    }
}

export const actions = {
    /**
     * Toggle the state of the Navigtion panel (mostly used with the open/
     * close hamburger button).
     * @param {*} param0
     */
    async toggleNav({commit, state}) {
        commit('setNavVisibility', (state.nav_visible ? false : true))
    },

    /**
     * Set the overall state of the site navigation.
     * @param {*} param0
     * @param {*} sta
     */
    async setNavState({commit}, sta) {
        commit('setNavState', sta)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
